import Tooltip from './Tooltip';

export default Tooltip;



// WEBPACK FOOTER //
// ./_rc-tooltip-3.4.9/src/index.js